import React from 'react';
import ListItem from 'components/ListItem';

// @ts-ignore
import PersonFullName from 'components/PersonFullName';
import { FertilizerOperatorPersonId } from 'services/fertilizerEvents/types';

export interface OwnProps {
    operatorPersonId: FertilizerOperatorPersonId;
}

type Props = OwnProps;

export default function SummaryApplicationApplicatorListItem(
    props: Props
): React.ReactElement {
    const { operatorPersonId } = props;

    return (
        <ListItem
            description="Applicator"
            value={<PersonFullName personId={operatorPersonId} />}
        />
    );
}
